import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { collection, getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBRZsnPfNeCApjasTR-A7jExTyYFuIhu90",
  authDomain: "ieee-940fe.firebaseapp.com",
  projectId: "ieee-940fe",
  storageBucket: "ieee-940fe.appspot.com",
  messagingSenderId: "61029903789",
  appId: "1:61029903789:web:a43d2bcec131cc1cd4c524",
  measurementId: "G-9FL8XLC6MG"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const userRef = collection(db, "applications");
const registerRef = collection(db, "registers");
const transactionIdRef = collection(db, "transactions");
const storage = getStorage(app);


export { db, userRef, registerRef, storage, transactionIdRef, auth }